export const columns = {
  criterionValues: 'Criteria',
  version: 'Version',
  status: 'Status',
  createdBy: 'Author',
  actions: 'Actions',
  label: 'Label',
  description: 'Description',
  code: 'Code',
  createdAt: 'Created at',
  updatedAt: 'Updated at',
  name: 'Name',
  nameAndSurname: 'First and last name',
  email: 'Email',
  roles: 'Roles',
  active: 'Active',
  stepLabel: 'Step',
  productIndex: 'Product index',
}
